import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgKeyboardArrowBigUp = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	fill: "currentColor",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16 7.773l3.28 3.28c0.52 0.52 1.36 0.52 1.88 0s0.52-1.36 0-1.88l-4.227-4.24c-0.52-0.52-1.36-0.52-1.88 0l-4.227 4.24c-0.52 0.52-0.52 1.36 0 1.88s1.36 0.52 1.88 0l3.293-3.28z" })
});
export default SvgKeyboardArrowBigUp;
